<template>
  <nav class="nav">
    <div class="navbar">
      <!-- <span @click="showMaskNav" class="icon" id="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          width="30"
          height="30"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
          />
        </svg>
      </span> -->
      <span class="logo">DinosPunchs</span>
    </div>
    <ul class="nav__items">
      <!-- <li>Favoris</li> -->
      <li>
        <select @change="changeAlbum" v-model="album" name="album">
          <option value="">Albums</option>
          <option value="imany">Imany</option>
          <option value="taciturne">Taciturne</option>
          <option value="sm">Stamina, Mémento</option>
          <option value="nautilus">Nautilus</option>
          <option value="sd">Sea Dweller</option>
          <option value="aquanaute">Aquanaute</option>
          <option value="hap">Hiver à Paris</option>
          <option value="o">Non clasés</option>
        </select>
      </li>
      <!-- <li>
        <input
          @change="changeColor"
          v-model="color"
          type="color"
          class="input__color"
        />
      </li> -->
    </ul>
  </nav>

  <div class="container">
    <div class="home">
      <div id="quote">
        <div class="box__quote">
          <p class="punch">
            <span class="coma"></span> {{ punchCurrent.quote }}
            <span class="coma"></span>
          </p>
          <!-- <span class="artist">~{{ punchCurrent.artist }}</span> -->
          <span class="album"
            >{{ `${punchCurrent.artist} ` }}
            {{
              ` ${punchCurrent.title ? "• " + punchCurrent.title : ""}`
            }}</span
          >
        </div>
        <p v-show="copyright" class="copyright">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
          >
            <path
              d="M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
          >
            <path
              d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
          >
            <path
              d="M20.947 8.305a6.53 6.53 0 0 0-.419-2.216 4.61 4.61 0 0 0-2.633-2.633 6.606 6.606 0 0 0-2.186-.42c-.962-.043-1.267-.055-3.709-.055s-2.755 0-3.71.055a6.606 6.606 0 0 0-2.185.42 4.607 4.607 0 0 0-2.633 2.633 6.554 6.554 0 0 0-.419 2.185c-.043.963-.056 1.268-.056 3.71s0 2.754.056 3.71c.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.043 1.268.056 3.71.056s2.755 0 3.71-.056a6.59 6.59 0 0 0 2.186-.419 4.615 4.615 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.187.043-.962.056-1.267.056-3.71-.002-2.442-.002-2.752-.058-3.709zm-8.953 8.297c-2.554 0-4.623-2.069-4.623-4.623s2.069-4.623 4.623-4.623a4.623 4.623 0 0 1 0 9.246zm4.807-8.339a1.077 1.077 0 0 1-1.078-1.078 1.077 1.077 0 1 1 2.155 0c0 .596-.482 1.078-1.077 1.078z"
            ></path>
            <circle cx="11.994" cy="11.979" r="3.003"></circle></svg
          >• Loïc Farel
        </p>
      </div>

      <div class="buttons">
        <button @click="prevPunche" title="Précedent" class="speak">
          <transition name="fade">
            <span v-show="paginationPrecedente" class="prev"
              >Pas de précédent.</span
            >
          </transition>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            width="38"
            height="38"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
        <button @click="nextPunche" title="Suivant" class="speak">
          <transition name="fade">
            <span v-show="paginationSuivante" class="suiv"
              >Pas de suivant.</span
            >
          </transition>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            width="38"
            height="38"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
        <button @click="capturer" id="capturer" title="Télécharger en image">
          <transition name="fade">
            <span v-show="notifDownload" class="download">{{
              textDownload
            }}</span>
          </transition>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            width="38"
            height="38"
          >
            <path
              fill-rule="evenodd"
              d="M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <button @click="speakPunch" class="speak">
          <transition name="fade">
            <span v-show="notifSpeak" class="speak__notif">Lecture..</span>
          </transition>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            width="38"
            height="38"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z"
            />
          </svg>
        </button>
        <button @click="copy" title="Copier dans la presse papier">
          <transition name="fade">
            <span v-show="notifCopy" class="copy">Copié !</span>
          </transition>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            width="38"
            height="38"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
            />
          </svg>
        </button>
      </div>

      <!-- <div class="diaporama">
        <button
          v-show="!playPause"
          @click="pause"
          title="Diaporama"
          class="speak"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            width="55"
            height="55"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
        <button
          v-show="playPause"
          @click="diaporama"
          title="Diaporama"
          class="speak"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            width="55"
            height="55"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
            />
          </svg>
        </button>
      </div> -->

      <div class="link">
        <p>
          Copyright &#169; •
          <a href="https://loicfarel.netlify.app"> Loïc Farel</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      punchCurrent: [],
      index: 0,
      album: "",
      punchs: [],
      color: "#120707",
      textDownload: "En cours...",
      notifDownload: false,
      notifCopy: false,
      notifSpeak: false,
      paginationPrecedente: false,
      paginationSuivante: false,
      diapoNext: true,
      playPause: true,
      getDiaporama: true,
      copyright: false,
    };
  },

  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        // index aléatoire
        let j = Math.floor(Math.random() * (i + 1));
        // echange
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    changeBackgroundCapture() {
      if (this.punchCurrent.album_key == "mg") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[0].img})`;
      } else if (this.punchCurrent.album_key == "taciturne") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[1].img})`;
      } else if (this.punchCurrent.album_key == "sm") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[2].img})`;
      } else if (this.punchCurrent.album_key == "imany") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[3].img})`;
      } else if (this.punchCurrent.album_key == "hap") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[4].img})`;
      } else if (this.punchCurrent.album_key == "aquanaute") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[5].img})`;
      } else if (this.punchCurrent.album_key == "nautilus") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[6].img})`;
      } else if (this.punchCurrent.album_key == "sd") {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[7].img})`;
      } else {
        document.querySelector(
          "#quote"
        ).style.backgroundImage = `url(${this.imagesFlou[8].img})`;
      }
    },
    changeBackground() {
      if (this.punchCurrent.album_key == "mg") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[0].img})`;
      } else if (this.punchCurrent.album_key == "taciturne") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[1].img})`;
      } else if (this.punchCurrent.album_key == "sm") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[2].img})`;
      } else if (this.punchCurrent.album_key == "imany") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[3].img})`;
      } else if (this.punchCurrent.album_key == "hap") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[4].img})`;
      } else if (this.punchCurrent.album_key == "aquanaute") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[5].img})`;
      } else if (this.punchCurrent.album_key == "nautilus") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[6].img})`;
      } else if (this.punchCurrent.album_key == "sd") {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[7].img})`;
      } else {
        document.querySelector(
          "body"
        ).style.backgroundImage = `url(${this.imagesAlbums[8].img})`;
      }
      // switch (this.punchCurrent.album_key) {
      //   case 1:
      //     "mg";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[0].img})`;
      //     break;
      //   case 2:
      //     "taciturne";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[1].img})`;
      //     break;
      //   case 3:
      //     "sm";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[2].img})`;
      //     break;
      //   case 4:
      //     "imany";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[3].img})`;
      //     break;
      //   case 5:
      //     "hap";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[4].img})`;
      //     break;
      //   case 6:
      //     "aquanaute";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[5].img})`;
      //     break;
      //   case 7:
      //     "nautilus";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[6].img})`;
      //     break;
      //   case 8:
      //     "sd";
      //     document.querySelector(
      //       "body"
      //     ).style.backgroundImage = `url(${this.imagesAlbums[7].img})`;
      //     break;
      //   default:
      //     break;
      // }
    },

    affectCurent() {
      this.punchCurrent = this.punchs[this.index];
      this.changeBackground();
    },

    nextPunch() {
      if (this.index < this.punchs.length - 1) {
        this.index++;
        this.affectCurent();
        this.animeQuote("anime-suivant");
      } else {
        this.paginationSuivante = true;
        setTimeout(() => {
          this.paginationSuivante = false;
        }, 800);
      }
    },

    prevPunch() {
      if (this.index > 0) {
        this.index--;
        this.affectCurent();
        this.animeQuote("anime-precedent");
      } else {
        this.paginationPrecedente = true;
        setTimeout(() => {
          this.paginationPrecedente = false;
        }, 800);
      }
    },

    togglePlay() {
      if (!this.playPause) {
        this.playPause = true;
      }
    },

    nextPunche() {
      this.diapoNext = true;
      this.setDiaporamaTrue();
      this.nextPunch();
      this.togglePlay();
    },

    prevPunche() {
      this.diapoNext = false;
      this.setDiaporamaTrue();
      this.prevPunch();
      this.togglePlay();
    },

    togglePlayPause() {
      if (this.playPause) {
        this.playPause = false;
      } else {
        this.playPause = true;
      }
    },

    setDiaporamaTrue() {
      if (this.getDiaporama) this.getDiaporama = false;
    },

    pause() {
      this.getDiaporama = false;
      this.togglePlayPause();
      // this.diaporama();
    },

    diaporama() {
      this.togglePlayPause();
      this.getDiaporama = true;
      if (this.diapoNext) {
        setInterval(() => {
          if (this.getDiaporama) {
            this.nextPunch();
          } else {
            return;
          }
        }, 4500);
      } else {
        setInterval(() => {
          if (this.getDiaporama) {
            this.prevPunch();
          } else {
            return;
          }
        }, 4500);
      }
    },

    changeAlbum() {
      this.index = 0;
      this.punchs = this.albums;
      this.affectCurent();
    },

    notifDownloadMask() {
      this.notifDownload = false;
    },

    capture() {
      this.textDownload = "En cours...";
      this.notifDownload = true;
      const srcElement = document.querySelector("#quote");
      html2canvas(srcElement, {
        backgroundColor: this.color,
        logging: false,
      })
        .then((canvas) => {
          const a = document.createElement("a");
          a.href = canvas.toDataURL();
          a.download = `punchDinos_${this.index}.jpg`;
          a.click();
          this.textDownload = "Téléchargé !";
          setTimeout(() => {
            this.notifDownloadMask();
          }, 800);
        })
        .catch(() => {
          this.textDownload = "Echoué !";
          setTimeout(() => {
            this.notifDownloadMask();
          }, 800);
        });
      document.querySelector("#quote").style.backgroundImage = "none";
      // this.afterCapture();
      this.copyright = false;
    },

    // beforeCapture() {
    //   // document.querySelector("#quote").style.width = "500px";
    //   // document.querySelector("#quote").style.height = "500px";
    // },

    // afterCapture() {
    // },

    capturer() {
      // this.beforeCapture();
      this.changeBackgroundCapture();
      this.copyright = true;
      setTimeout(() => {
        this.capture();
      }, 1);
    },

    copy() {
      this.notifCopy = true;
      navigator.clipboard.writeText(
        `${this.punchCurrent.quote}\n${this.punchCurrent.album} • ${this.punchCurrent.title}`
      );

      setTimeout(() => {
        this.notifCopy = false;
      }, 800);
    },

    changeColor() {
      localStorage.setItem("color", JSON.stringify(this.color));
    },

    animeQuote(classe) {
      const quote = document.querySelector(".box__quote");
      quote.classList.add(classe);
      setTimeout(() => {
        quote.classList.remove(classe);
      }, 410);
    },

    speakPunch() {
      let utterance = new SpeechSynthesisUtterance(
        `${this.punchCurrent.quote}`
        // `${this.punchCurrent.quote} ${this.punchCurrent.album ? "album" : ""}  ${this.punchCurrent.album}, titre ${this.punchCurrent.title} . `
      );
      speechSynthesis.speak(utterance);
      utterance.onstart = () => {
        this.speakNoneAddButton();
        this.notifSpeak = true;
      };
      utterance.onend = () => {
        this.speakNoneRemoveButton();
        this.notifSpeak = false;
      };
      // this.notifSpeak = false
    },

    speakNoneAddButton() {
      let buttons = document.querySelectorAll(".speak");
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.add("none__button");
      }
    },

    speakNoneRemoveButton() {
      let buttons = document.querySelectorAll(".speak");
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove("none__button");
      }
    },
  },

  computed: {
    ...mapGetters(["punchse", "imagesAlbums", "imagesFlou"]),

    albums() {
      return this.punchse.filter((punch) => {
        return punch.album_key.toLowerCase().includes(this.album.toLowerCase());
      });
    },
  },

  mounted() {
    this.punchs = this.punchse;
    this.shuffleArray(this.punchs);
    this.affectCurent();
    if (JSON.parse(localStorage.getItem("color"))) {
      this.color = JSON.parse(localStorage.getItem("color"));
    }
  },
};
</script>
<style scoped>
.icon {
  display: none;
}
.nav {
  width: 100%;
  display: flex;
  right: 0;
  top: 0;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 0 5px;
  height: 50px;
  z-index: 9999;
  position: fixed;
  font-size: 17px;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 0 1rem; */
  width: 100%;
}

.nav .logo {
  font-size: 20px;
  font-weight: 600;
}

li {
  list-style: none;
  cursor: pointer;
  /* padding: 0 10px; */
}

select {
  outline: none;
  height: 25px;
  cursor: pointer;
  font-size: 15px;
  color: #000 !important;
  background: #fff !important;

  font-family: "Regular";
}

option {
  color: #000 !important;
  background: #fff !important;
}

/* .input__color {
  width: 30px;
  height: 25px;
  cursor: pointer;
} */

.nav__items {
  display: flex;
  gap: 0.5rem;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  color: aliceblue;
  /* backdrop-filter: blur(2px); */
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
}

.home {
  display: table-cell;
  vertical-align: middle;
}

.box__quote {
  width: 600px;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff !important;
  /* background: url("../assets/cover/flou/nautilus.jpg"); */
  gap: 20px;
  padding: 10px;
}

#quote {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  /* border: 1px dashed #fff; */
}
@media screen and (max-width: 615px) {
  .box__quote {
    width: 100%;
  }
}

.anime-precedent {
  animation: slidePrecedent 0.5s;
}

.anime-suivant {
  animation: slideSuivant 0.5s;
}

@keyframes slidePrecedent {
  100% {
    opacity: 0;
    transform: translateX(300px);
  }
}

@keyframes slideSuivant {
  100% {
    opacity: 0;
    transform: translateX(-300px);
  }
}

.box__quote p {
  /* display: flex;
  align-items: center;
  justify-content: center; */
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  /* min-height: 100px; */
}

.coma {
  font-size: 20px;
}

.box__quote .artist {
  display: block;
  font-style: italic;
  text-align: right;
  /* margin: 1rem 0; */
  font-size: 23px;
  padding-right: 2rem;
}

.box__quote .album {
  font-size: 20px;
  text-align: center;
  font-style: italic;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* margin-top: 25px; */
  gap: 5px;
}

@media screen and (max-width: 279px) {
  .buttons {
    flex-wrap: wrap;
  }
}

.buttons button {
  padding: 10px;
  cursor: pointer;
}

button {
  background: none;
  outline: none;
  border: none;
  color: #fff;
  font-family: "Regular";
}

.download {
  margin: -28px 0px 0px -25px;
  padding: 0.25rem 0.5rem !important;
}

.download,
.copy,
.prev,
.suiv,
.speak__notif {
  position: fixed;
  color: #000;
  background: #fff;
  border-radius: 15px;
  font-size: 15px;
}

.prev,
.suiv {
  margin: -28px 0px 0px -5px;
  padding: 0.15rem 0.25rem !important;
}

.copy {
  margin: -28px 0px 0px -5px;
  padding: 0.15rem 0.25rem !important;
}

.speak__notif {
  margin: -28px 0px 0px -15px;
  padding: 0.15rem 0.25rem !important;
}

.link {
  display: flex;
  justify-content: center;
  margin-top: 70px;
  font-size: 17px;
}

.link a {
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  /* border-bottom: 1px solid #fff; */
}

svg:hover {
  color: rgb(255, 255, 255, 0.7);
  padding: 1px;
  transition: all 0.2s ease-in;
}

.diaporama {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.diaporama button {
  cursor: pointer;
}

.none__button {
  pointer-events: none;
}

.copyright {
  font-size: 12px !important;
  font-weight: 500 !important;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 5px;
  margin-bottom: 10px;
}

.copyright svg {
  /* border: 1px solid #fff;
  border-radius: 50%; */
  fill: #fff;
}
</style>
